/**
 * Default instructions for custom feedback scenarios
 * Separated to avoid circular dependencies between playground-state and feedback-presets
 */
export const defaultCustomFeedbackInstructions = `CLINICAL FEEDBACK REPORTING TEMPLATE:

This is a template to help you create custom clinical feedback reporting scenarios. Fill in each section with details about your feedback session.

SESSION DETAILS:
[Provide session information]
Session Type: [e.g., Post-Procedure Debrief, Case Presentation, Observed Encounter]
Clinical Domain: [e.g., Surgery, Internal Medicine, Emergency Medicine]
Procedure/Activity: [Specific skill or activity being reviewed]
Clinical Setting: [e.g., Simulation Lab, Hospital Ward, Clinic]
Date: Current Session

INSTRUCTOR PROFILE:
[Provide instructor information]
Name: [Instructor name]
Credentials: [e.g., MD, FACS, RN, MSN]
Role: [e.g., Attending Physician, Clinical Preceptor]
Specialty: [Clinical specialty]
Experience: [Years of teaching experience]
Teaching Style: [e.g., Socratic, Direct, Demonstration-focused]

TRAINEE PROFILE:
[Provide trainee information]
Name: [Trainee name]
Level: [e.g., PGY-1, MS-3, Nursing Student]
Program: [Training program]
Prior Experience: [Relevant prior experience]
Learning Objectives: [Specific learning goals for this session]

COMPETENCY FRAMEWORK:
[Specify the competency framework being used]
Framework: [e.g., ACGME Core Competencies, CanMEDS, QSEN]
Relevant Competencies: [List specific competencies being assessed]

REPORT PARAMETERS:
[Customize what the report should focus on]
- [Specific feedback area 1]
- [Specific feedback area 2]
- [Specific feedback area 3]
- [Additional focus areas as needed]

CRITICAL DOCUMENTATION RULES:
1. Every feedback item MUST have exact verbatim quote from instructor
2. Do NOT interpret or assume feedback not explicitly stated
3. Distinguish instructor's stated recommendations from elaborated suggestions
4. Connect feedback to clinical relevance and patient outcomes
5. Provide actionable, specific recommendations for improvement
6. Map feedback to relevant competency framework domains

ADDITIONAL CONTEXT:
[Any additional context specific to this feedback scenario]`;
